<template>
    <popup :show="true" width="520px" @on-close="onClose">
        <div class="remove-member">
            <div class="remove-pop-title">
                <img src="@/assets/images/team/icon-team-remove.png" alt="" />移出团队
            </div>
            <div class="remove-pop-content">
                移出成员后,TA将无法访问团队的任何项目、文件、资源库,是否继续移出?
            </div>
            <div class="btn-box">
                <div class="btn" @click="onClose">取消</div>
                <div class="btn" @click="removeMember">确定</div>
            </div>
        </div>
    </popup>
</template>
<script>
import { removeMember } from '@/api/index';
import Popup from '@/components/Popup.vue';
export default{
    name:"RemoveMember",
    components:{
        Popup
    },
    props:{
        memberId:{
            type:String,
            default:""
        },
        teamId:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            member_id:'',
            team_id:''
        }
    },
    mounted(){
        this.member_id = this.memberId;
        this.team_id = this.teamId;
    },
    methods:{
        async removeMember(){
            try{
                const {code,msg} = await removeMember({uuid:this.team_id,user_id:this.member_id});
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('成功移除成员');
                this.$emit('on-remove');
                this.$emit('on-close');
            }catch(e){
                console.log('err-remove-member',e);
                this.$layer.msg(e.msg);
            }
        },
        onClose(){
            this.$emit('on-close');
        }
    }
}
</script>
<style lang="scss" scoped>
.remove-member{
    width:100%;
    height:359px;
    border-radius:15px;
    background:#ffffff;
    display:flex;
    justify-content:center;
    align-items:center;
    flex-direction:column;
    .remove-pop-title{
        display:flex;
        align-items:center;
        column-gap:6px;
        color:#1a1a1a;
        font-size:24px;
        font-weight:bold;
        img{
            width:26px;
            height:26px;
        }
    }
    .remove-pop-content{
        width:372px;
        text-align:center;
        white-space:wrap;
        color:#666666;
        font-size:14px;
        line-height:28px;
        margin-top:35px;
    }
    .btn-box{
        width:100%;
        margin-top:100px;
        display:flex;
        justify-content:center;
        column-gap:10px;
        .btn{
            width:110px;
            height:32px;
            border-radius:6px;
            background:#ffffff;
            border:1px solid #dedee0;
            line-height:32px;
            text-align:center;
            cursor:pointer;
            color:#4d4d4d;
            font-size:14px;
            &:last-child{
                color:#ffffff;
                background:#ff5967;
                border:none;
            }
        }
    }
}
</style>